export default __webpack_public_path__ + "static/js-02374a60ba917301ba45011f073c9d2b.png";